<template>
  <div class="contact-us" @click="handleClick">
    <img src="../assets/frame.svg" alt="" />
    联系我们
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  data() {
    return {};
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="less" scoped>
.contact-us {
  cursor: pointer;
  position: fixed;
  top: 542px;
  right: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 74px;
  height: 74px;
  background: linear-gradient(180deg, #496bff 6%, #2a51f8 100%);
  box-shadow: 0px 12px 14px 0px rgba(53, 91, 251, 0.24);
  border-radius: 50%;
  transition: all 0.6s ease-in-out;
  color: #fff;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC;
  letter-spacing: 1px;
  z-index: 99;
  img {
    width: 30px;
    height: 30px;
    margin-bottom: 2px;
  }
  &:hover {
    box-shadow: 0px 12px 14px 0px rgba(53, 91, 251, 0.5);
  }
}
</style>
